import { findIndex } from "lodash";

export class ItemEdit {
    public static $inject: string[] = [];

    public categories: Array<any> = [];
    public currentIndex: number;
    public currentItem;
    public isOpen: boolean = false;
    public items: Array<any> = [];
    public nextItem;
    public originalItem;
    public previousItem;
    public filterItemsArray: Array<any> = [];

    protected saleCurrencySymbol: string;

    constructor(protected _) {}

    public close() {
        this.isOpen = false;
    }

    public next() {
        this.currentIndex++;
        const oldCurrentItem = this.currentItem;
        this.currentItem = this.nextItem;
        this.originalItem = angular.copy(this.currentItem);
        this.previousItem = oldCurrentItem;

        if (this.filterItemsArray[this.currentIndex + 1]) {
            this.nextItem = this.filterItemsArray[this.currentIndex + 1];
        } else {
            this.nextItem = null;
        }
    }

    public open(itemId) {
        this.filterItemsArray = this.getFilteredItems();
        this.currentIndex = findIndex(
            this.filterItemsArray,
            item => {
                return item.id === itemId;
            }
        );

        this._initCurrentItem();
        this._toggle();
    }

    public previous() {
        this.currentIndex--;
        const oldCurrentItem = this.currentItem;
        this.currentItem = this.previousItem;
        this.originalItem = angular.copy(this.currentItem);
        this.nextItem = oldCurrentItem;

        if (this.filterItemsArray[this.currentIndex - 1]) {
            this.previousItem = this.filterItemsArray[this.currentIndex - 1];
        } else {
            this.previousItem = null;
        }
    }

    public resetCurrentItem() {
        if (!this.currentItem) {
            this.currentItem = {};
        }
        this.currentItem = (<any>Object).assign(this.currentItem, this.originalItem);
    }

    public setCategories(categories) {
        this.categories = categories;
    }

    public setItems(items) {
        this.items = items;
    }

    public getFilteredItems() {
        let _filterItemsArray = this.items.filter(item => item.filtered === false);
        if (_filterItemsArray.length === 0) {
            _filterItemsArray = this.items;
        }
        return _filterItemsArray;
    }

    protected _initCurrentItem() {
        this.currentItem = this.filterItemsArray[this.currentIndex];
        this.originalItem = angular.copy(this.currentItem);

        if (this.currentIndex > 0) {
            this.previousItem = this.filterItemsArray[this.currentIndex - 1];
        } else {
            this.previousItem = null;
        }

        if (this.currentIndex < this.items.length - 1) {
            this.nextItem = this.filterItemsArray[this.currentIndex + 1];
        } else {
            this.nextItem = null;
        }
    }

    private _toggle() {
        this.isOpen = !this.isOpen;
    }
}
